export const WHITESPACE = '\u00A0';
